import { withAuthenticationRequired } from "@auth0/auth0-react";
import Hilti_LayerMenuComponent from '../components/Hilti_LayerMenu';
import React from "react";

export const Hilti_ProtectedRoute = ({ component }) => {
  const Component = withAuthenticationRequired(component, {
    onRedirecting: () => (
      <div className="pos-center">
        <div className="loader"></div>
      </div>
    ),
  });

  return(
    <div>
      <Component />
      <Hilti_LayerMenuComponent />
    </div>
  )
};